import React from 'react';
import PropTypes from 'prop-types';

import SecondaryNav from './footer/secondary_nav';

import './style.scss';

const Footer = ({ footer }) => {
    return (
        <footer className="container-fluid">
            <div className="inner-container">
                <SecondaryNav footer={footer} />
                <div>
                    <div className="disclaimer">
                        <p>
                            Must be 18 to play the New Hampshire Lottery.
                            <br />
                            <a href="https://nhlottery.com/Play-Responsibly">
                                Play Responsibly
                            </a>{' '}
                            - If you have a problem with gambling, help is
                            available.
                            <br />
                        </p>
                        <p>
                            007 and related James Bond Indicia © 1962-2020
                            Danjaq, LLC and Metro-Goldwyn-Mayer Studios Inc.
                            <br />
                            007 and related James Bond Trademarks are trademarks
                            of Danjaq, LLC. All Rights Reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    footer: PropTypes.array.isRequired,
};

export default Footer;
